import { useState } from "react";

export function useCRUDFilters(data, columns, searchFields, options = {}) {
  const { useServerFiltering = true } = options; // Default to server-side filtering
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [sortBy, setSortBy] = useState(columns[0]?.key || "name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const handleSearchChange = (query) => {
    setSearchQuery(query);
    setCurrentPage(1);
  };

  // When using server-side filtering, skip client-side search and status filtering
  // The server already returns filtered results
  const filteredData = useServerFiltering
    ? (Array.isArray(data) ? data : [])
    : (Array.isArray(data) ? data : []).filter((item) => {
        const fieldsToSearch =
          searchFields.length > 0 ? searchFields : columns.map((col) => col.key);

        const matchesSearch =
          !searchQuery ||
          fieldsToSearch.some((field) => {
            const value = item[field]?.toString().toLowerCase() || "";
            return value.includes(searchQuery.toLowerCase());
          });

        const matchesStatus = filterStatus === "all" ||
          item.status?.toLowerCase() === filterStatus.toLowerCase() ||
          item.status?.value?.toLowerCase() === filterStatus.toLowerCase() ||
          item.status?.name?.toLowerCase() === filterStatus.toLowerCase();

        return matchesSearch && matchesStatus;
      });


  // When using server-side filtering, skip client-side sorting (server returns data in correct order)
  const sortedData = useServerFiltering
    ? filteredData
    : [...filteredData].sort((a, b) => {
        let aVal = a[sortBy]?.toString().toLowerCase() || "";
        let bVal = b[sortBy]?.toString().toLowerCase() || "";

        if (sortOrder === "asc") {
          return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
        } else {
          return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
        }
      });

  const totalItems = sortedData.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  // When using server-side filtering/pagination, return all data (already paginated by server)
  const currentItems = useServerFiltering ? sortedData : sortedData.slice(startIndex, endIndex);

  return {
    searchQuery,
    filterStatus,
    sortBy,
    sortOrder,
    currentPage,
    totalItems,
    totalPages,
    startIndex,
    endIndex,
    currentItems,
    setFilterStatus,
    setCurrentPage,
    handleSort,
    handleSearchChange,
  };
}
